import React from 'react';
import { useDispatch } from 'react-redux';
import { FileArchiveInfo } from 'redux/middleware/api/video-export-service/types';
import { goToProjects } from 'redux/modules/router';
import { Dispatch } from 'redux/types';
import DownloadPageArchivedVideoSection from '../DownloadPageArchivedVideoSection';
import DownloadPageRestoringVideoSection from '../DownloadPageRestoringVideoSection';

export interface DownloadPageArchivingVideoSectionProps {
  embedVideoId: number;
  fileArchiveInfo: FileArchiveInfo;
  aspectRatioName?: string;
}

const DownloadPageArchivingVideoSection: React.FC<DownloadPageArchivingVideoSectionProps> = ({
  embedVideoId,
  fileArchiveInfo,
  aspectRatioName,
}) => {
  const { isFileArchived, isRestoreInProgress } = fileArchiveInfo;

  const dispatch = useDispatch<Dispatch>();

  if (isFileArchived) {
    return (
      <DownloadPageArchivedVideoSection
        embedVideoId={embedVideoId}
        onRestoreSuccess={() => dispatch(goToProjects())}
      />
    );
  }

  if (isRestoreInProgress) {
    return (
      <DownloadPageRestoringVideoSection aspectRatioName={aspectRatioName} />
    );
  }

  return null;
};

export default DownloadPageArchivingVideoSection;
